import { render } from "./Shipping.vue?vue&type=template&id=76ae9cc5&scoped=true"
import script from "./Shipping.vue?vue&type=script&lang=js"
export * from "./Shipping.vue?vue&type=script&lang=js"

import "./Shipping.vue?vue&type=style&index=0&id=76ae9cc5&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76ae9cc5"]])

export default __exports__